<div class="list-tarifs">
  <div class="container content">
    <ng-container *ngIf="selectedDep">
      <h3 class="text-uppercase accent">
        Honoraires maximum TTC<br/>{{honoraires[selectedDep]?.num}} - {{honoraires[selectedDep]?.club[0].nom}}
      </h3>
      <div class="container my-3">
        <app-fees-amis [dep]="honoraires[selectedDep]" [colorText]="['']"></app-fees-amis>
      </div>
    </ng-container>
    <ng-container *ngIf="!selectedDep">
      <h3 class="text-uppercase accent">Nos honoraires maximum</h3>
    </ng-container>

    <div class="card-box">
      <div class="row">
        <div *ngFor="let dep of listDepsSearched" class="col-lg-3 col-xl-2">
<!--          <div (click)="selectedDep = dep.num" data-toggle="tooltip"-->
<!--             data-placement="top"-->
<!--             ngbTooltip="{{dep.num}} - {{dep.nom}}">-->
          <a [routerLink]="['/nos-concessions/'+dep.club[0].url_club+'/'+dep.num+'/honoraires']" data-toggle="tooltip"
             data-placement="top"
             ngbTooltip="{{dep.num}} - {{dep.nom}}">
            <div class="file-man-box" >
              <div class="file-man-title">
                <h5 class="mb-0 text-overflow">{{dep.num}} - {{dep.nom}}</h5>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
